module.exports = {"title":"ShowTix4U Star Printers","addPrinter":"Add a new Star printer","printers":"Printers","existingPrinters":"Existing Printers","name":"Name","ip":"IP Address","edit":"Edit","makeDefault":"Make Default Printer","save":"Save","cancel":"Cancel","update":"Update","delete":"Delete","tips":[{"title":"Tip","content":"<p><a href='http://equipment.showtix4u.com' target='_blank'>Shop for a Star Printer</a></p>"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Client/Star/locales/en.json
// module id = 2007
// module chunks = 0